var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('IndividualSessionLayout',{attrs:{"session-id":_vm.sessionId,"end-of-time-handler":_vm.endOfIndividualSessionHandler,"set-up-task-handler":_vm.setUpTask}},[_c('RankingTask',{attrs:{"submit-ranking-handler":_vm.endOfIndividualSessionHandler,"session-id":_vm.sessionId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }